import { BdaDataset } from "./BdaDataset";
import { BdaModel } from "./BdaModel";
import { WorkflowStatusModel } from "./Workflow";
import { AccessLevel, Organization, Owner } from "./generics";

export interface Framework {
  id: number;
  name: string;
  imageUrl: string;
  version: string;
}

export type ServiceMode = 'BATCH' | 'SOURCE' | 'PROCESSOR' | 'SINK';

export class BdaService {
  accessLevel?: AccessLevel;
  area?: string;
  description: string;
  framework?: Framework;
  id?: number;
  label?: string;
  metrics?: any[]; // TODO improve type
  mode: ServiceMode;
  models?: BdaModel[];
  name: string;
  organization?: Organization;
  owner?: Owner;
  properties: BdaServiceProperty[];
  ref?: string;
  statusModel?: WorkflowStatusModel;
  tags: string[];
  url: string;
  version: string;

  constructor() {
    this.name = '';
    this.description = '';
    this.mode = 'BATCH';
    this.area = undefined;
    this.version = "";
    this.framework = undefined;
    this.properties = [];
    this.url = '';
    this.tags = [];
  }
}

export class BdaServiceProperty {
  id?: number;
  defaultValue: any;
  description: string;
  invisible: boolean;
  key: string;
  mandatory: boolean;
  type: 'application' | 'tuning' | 'static';
  valueType: 'STRING' | 'BOOLEAN' | 'INT' | 'DOUBLE' | 'JSON';
  value: any;
  dataset?: Partial<BdaDataset>;
  model?: Partial<BdaModel>;
  extra?: any; // datasetType, mode

  constructor(type: 'application' | 'tuning' | 'static') {
    this.defaultValue = null;
    this.description = "";
    this.invisible = false;
    this.key = "";
    this.mandatory = false;
    this.type = type;
    this.valueType = "STRING";
  }
}

export class BdaServiceApplicationProperty extends BdaServiceProperty {
  inputData: boolean;
  outputData: boolean;
  obfuscated: boolean;

  constructor() {
    super('application');
    this.inputData = false;
    this.outputData = false;
    this.obfuscated = false;
  }
}

export class BdaServiceTuningProperty extends BdaServiceProperty {
  maxValue: string;
  minValue: string;
  measure: string;
  mappings: TuningPropertyMapping[];
  category: boolean;

  constructor() {
    super("tuning");
    this.maxValue = "";
    this.minValue = "";
    this.measure = "";
    this.mappings = [];
    this.category = false;
    // this.numberOfReplicas = 0;
  }
}

export class BdaServiceStaticProperty extends BdaServiceProperty {
  externalized: boolean;
  uri: string;

  constructor() {
    super("static");
    this.externalized = false;
    this.uri = "";
  }
}

export interface TuningPropertyMapping {
  name: string;
  intValue: string | number;
}